module.exports = __webpack_public_path__ + "img/Mote.1c54fef7.png";